<template>
  <div class="all-content" :style="[ isText ? 'background: white;' : '']">
    <div class="content">
      <template v-for="item in grades">
        <div :key="item.key">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 275.3 413.3"
            enable-background="new 0 0 275.3 413.3"
            xml:space="preserve"
            width="40px"
            height="40px"
          >
            <!-- 关，填充 -->
            <g id="off">
              <path
                fill="#E2ECF1"
                d="M137.7,13.7C67.2,13.7,10,70.9,10,141.4c0,58.3,72.8,118.2,79.9,162.3h47.8h47.8
              c7.1-44,79.9-103.9,79.9-162.3C265.3,70.9,208.2,13.7,137.7,13.7z"
              ></path>
            </g>

            <!-- 开，填充 v-if="item.isActive" -->
            <g class="on" :class="{ activation: item.isActive}">
              <path
                fill="#5dac5b"
                d="M137.7,13.7C67.2,13.7,10,70.9,10,141.4c0,58.3,72.8,118.2,79.9,162.3h47.8h47.8
              c7.1-44,79.9-103.9,79.9-162.3C265.3,70.9,208.2,13.7,137.7,13.7z"
              ></path>
            </g>

            <!-- 边框，开关都是一个边框 -->
            <g id="outline">
              <path
                fill="#F1F2F2"
                stroke="#38434A"
                stroke-width="19.1022"
                stroke-miterlimit="10"
                d="M168.5,375.5h-61.7c-8.9,0-16-7.2-16-16
              v-55.8h93.8v55.8C184.6,368.3,177.4,375.5,168.5,375.5z"
              ></path>
              <path
                fill="#F1F2F2"
                stroke="#38434A"
                stroke-width="19.1022"
                stroke-miterlimit="10"
                d="M151.2,401.5h-27.1c-3.9,0-7-3.2-7-7v-19
              h41.1v19C158.2,398.4,155.1,401.5,151.2,401.5z"
              ></path>
              <line
                fill="none"
                stroke="#38434A"
                stroke-width="19.1022"
                stroke-miterlimit="10"
                x1="184.6"
                y1="339.6"
                x2="90.8"
                y2="339.6"
              ></line>
              <path
                fill="none"
                stroke="#38434A"
                stroke-width="19.1022"
                stroke-miterlimit="10"
                d="M137.7,13.7C67.2,13.7,10,70.9,10,141.4
              c0,58.3,72.8,118.2,79.9,162.3h47.8h47.8c7.1-44,79.9-103.9,79.9-162.3C265.3,70.9,208.2,13.7,137.7,13.7z"
              ></path>
            </g>

            <!-- 这个不知道是什么 -->
            <g id="highlight">
              <path
                fill="#FFDB55"
                stroke="#FFFFFF"
                stroke-width="21.0124"
                stroke-linecap="round"
                stroke-miterlimit="10"
                d="M207.1,89.5
              c-12.3-16.1-28.4-29.1-46.9-37.8"
              ></path>
              <path
                fill="#FFDB55"
                stroke="#FFFFFF"
                stroke-width="21.0124"
                stroke-linecap="round"
                stroke-miterlimit="10"
                d="M225,121.4
              c-0.8-2.2-1.8-4.4-2.7-6.5"
              ></path>
            </g>
          </svg>
        </div>
      </template>
    </div>
    <template v-if="isText">
    <div class="sub-content" v-if="!isShowSmall">
      <template v-if="isShowDetail">
        <p>1. 当前奖励金标准为 {{ money }} 元</p>
        <p>2. 回答一次问卷会点亮一盏灯</p>
        <p>3. 每点亮一盏灯，奖励金标准会+1元</p>
        <p>4. 5盏灯全亮进入大满贯模式，回答成功可保持，再次失败奖励金标准复原到2元</p>
      </template>
      <template v-else>
        <p class="p-center">奖励金额已升级为 {{ money }} 元，再次成功参与即刻兑付！</p>
      </template>
    </div>
    </template>
  </div>
</template>

<script>
import { getCookie } from '../utils';

export default {
  props: ['show', 'small', 'txt'],
  data() {
    return {
      money: 2,
      isShowDetail: true,
      isShowSmall: false,
      isText: true,
      grades: [
        { key: 1, isActive: false, isAnimate: false },
        { key: 2, isActive: false, isAnimate: false },
        { key: 3, isActive: false, isAnimate: false },
        { key: 4, isActive: false, isAnimate: false },
        { key: 5, isActive: false, isAnimate: false }
      ]
    };
  },

  mounted() {
    this.request();
    if (this.small == 'true') {
      this.isShowSmall = true;
    }else {
      this.isShowSmall = false;
    }

    if (this.show == 'false') {
      this.isShowDetail = false;
    }else {
      this.isShowDetail = true;
    }

    if (this.txt == 'false') {
      this.isText = false;
    }else {
      this.isText = true;
    }
  },

  methods: {
    request() {
      let unionId = getCookie('unionId');
      this.axios.get('https://home.51point.com/51point-0.0.1-SNAPSHOT/challengelevel/getChallengeLevelForPc', { params: { param: unionId } }).then(res => {
        console.log(res)
        if (res.data.data && res.data.data.length > 0) {
          setTimeout(() => {
            for (let i = 0; i < 5; i++ ) {
              if (i < res.data.data[0].prnowlevel) {
                const time = 1000 + 100 * i
                setTimeout(() => {
                  this.grades[i].isActive = true   
                }, time);             
              }
            }
          }, 100);
          this.money = res.data.data[0].prnowlevel
        }else {
          // 默认状态，只亮 2 个灯
          setTimeout(() => {
            this.grades[0].isActive = true
          }, 800);
          setTimeout(() => {
            this.grades[1].isActive = true
          }, 900);
          this.money = 2
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:900);

.grade {
  width: 20px;
  height: 20px;
  border: 1px solid black;
  margin: 10px;
}

.animate {
  animation: breathe 1500ms ease-in-out infinite alternate;
}

.all-content {
  padding: 10px 10px;
  border-radius: 0.4rem;
  // background: white;
  margin: 0.3rem 1rem;
  display: flex;
  flex-direction: column;
}

.content {
  margin: 0.5rem 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.sub-content {
  margin: 0.5rem 0.5rem;
  padding: 1rem 0rem;
}

.p-center {
  text-align: center;
}

.sub-content p {
  font-size: 12px;
  color: #666;
  line-height: 20px;
  letter-spacing: 0;
}

img {
  width: 4.7rem;
  height: 7.7rem;
  margin: 1rem 0rem;
  background-size: 4.7rem 7.7rem;
}

.on {
  // animation: zoom 1s ease-in;
  // transition: all 0.14s ease-in;
  transform: translate(50%, 50%) scale(0);
  opacity: 0;
}

.activation {
  opacity: 1;
  transform: translate(0) scale(1);
  transition: all 0.2s ease-in-out;
}

@keyframes zoom {
  0% {
    opacity: 0;
    // transform: translate(50%, 50%) scale(0);
    transform: scale(0);
  }

  100% {
    opacity: 1;
    // transform: translate(0) scale(1);
    transform: scale(1);
  }
}

@keyframes breathe {
  0% {
    opacity: 0.4;
    transform: scale(0.5);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

$button-width: 150px;
$button-height: 65px;
$button-color: #38434a;
$button-font-size: 1.9em;

$bulb-width: 212px;
$bulb-height: 190px;
// $bulb-width: 52px;
// $bulb-height: 60px;
$bulb-color: lighten(crimson, 5%);
$bulb-font-size: 1.9em;

$light-color: #5dac5b;
$streak-vert-space: 65px; //vertical spacing between streaks
$streak-horizontal-offset: 5px; //initial offset
$streak-distance: 10px; //distance moved by streaks
$streak-stagger: 15px; //distance between center and edge streaks

$streak-rotation: 34deg;
$streak-height: 11px;
$streak-width: 50px;

$speed: 0.38s;
$timing-function: ease-out;
$speed-of-light: 0.14s;
$animation-delay: $speed-of-light;
body,
html {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
body {
  background: darken(#e2ecf1, 15%);
  transition: all $speed-of-light ease-in;
}
body.active {
  background: lighten(#e2ecf1, 5%);
}
.container {
  margin: auto;
  width: $bulb-width;
}
.power {
  margin: auto;
  margin-top: 20px;
  background: $button-color;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-family: Roboto;
  font-size: $button-font-size;
  height: $button-height;
  letter-spacing: 0.2px;
  line-height: $button-height;
  text-align: center;
  user-select: none;
  width: $button-width;
  transition: none;

  &:hover {
    background: lighten($button-color, 4%);
  }
  &:active {
    box-shadow: inset 0px 4px 10px 0px darken($button-color, 5%);
    transition: background $speed-of-light ease-in;
  }
  .active & {
    background: #58c48d;
    &:active {
      box-shadow: inset 0px 6px 8px -1px darken(#58c48d, 7%);
    }
  }
}
// #on {
//   transform: translate(50%, 50%) scale(0);
//   opacity: 0;
//   .active & {
//     opacity: 1;
//     transform: translate(0) scale(1);
//     transition: all $speed-of-light ease-in;
//   }
// }
.fancy-bulb {
  position: relative;
}
.streaks,
.streaks:after,
.streaks:before {
  position: absolute;
  // background:$light-color;
  background: #5dac5b;
  border-radius: ($streak-height/2);
  height: $streak-height;
}
.streaks:after,
.streaks:before {
  content: "";
  display: block;
}
.streaks:before {
  bottom: $streak-vert-space;
}
.streaks:after {
  top: $streak-vert-space;
}
.left-streaks {
  right: $bulb-width + $streak-horizontal-offset;
  top: ($bulb-height/2)- ($streak-height/2);
  .active & {
    animation: move-left $speed $timing-function,
      width-to-zero $speed $timing-function;
    animation-delay: $animation-delay;
  }

  &:before,
  &:after {
    left: $streak-stagger;
  }
  &:before {
    .active & {
      animation: width-to-zero $speed $timing-function,
        move-up $speed $timing-function;
      animation-delay: $animation-delay;
    }
  }
  &:after {
    .active & {
      animation: width-to-zero $speed $timing-function,
        move-down $speed $timing-function;
      animation-delay: $animation-delay;
    }
  }
}
.right-streaks {
  left: $bulb-width + $streak-horizontal-offset;
  top: ($bulb-height/2)- ($streak-height/2);
  .active & {
    animation: move-right $speed $timing-function,
      width-to-zero $speed $timing-function;
    animation-delay: $animation-delay;
  }
  &:before,
  &:after {
    right: $streak-stagger;
  }
  &:before {
    .active & {
      animation: width-to-zero $speed $timing-function,
        move-up $speed $timing-function;
      animation-delay: $animation-delay;
    }
  }
  &:after {
    .active & {
      animation: width-to-zero $speed $timing-function,
        move-down $speed $timing-function;
      animation-delay: $animation-delay;
    }
  }
}

.left-streaks:before,
.right-streaks:after {
  transform: rotate($streak-rotation);
}

.left-streaks:after,
.right-streaks:before {
  transform: rotate(-$streak-rotation);
}

@keyframes move-left {
  0% {
    transform: none;
  }
  65% {
    transform: translateX(-1 * $streak-distance);
  }
  100% {
    transform: translateX(-1 * $streak-distance);
  }
}
@keyframes move-right {
  0% {
    transform: none;
  }
  65% {
    transform: translateX($streak-distance);
  }
  100% {
    transform: translateX($streak-distance);
  }
}
@keyframes width-to-zero {
  0% {
    width: $streak-width;
  }
  100% {
    width: $streak-height;
  }
}
@keyframes move-up {
  0% {
  }
  100% {
    bottom: $streak-vert-space * 1.55;
  }
}
@keyframes move-down {
  0% {
  }
  100% {
    top: $streak-vert-space * 1.55;
  }
}
</style>
